import React__default, { createElement, useState, useEffect, Fragment } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Text, Icon } from '@it25syv/25syv-ui';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var MenuWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  background: ", ";\n  color: black;\n  z-index: ", ";\n  box-shadow: 0 0 10px #0e449a33;\n  border-radius: 20px 20px 0 0;\n  padding: 12px 22px;\n  ", ";\n  @media screen and (min-width: 768px) {\n    max-width: 400px;\n    right: 0;\n  }\n"])), function (_ref) {
  var background = _ref.background;
  return background || 'white';
}, function (_ref2) {
  var zIndexWrapper = _ref2.zIndexWrapper;
  return zIndexWrapper + 1 || 112;
}, function (_ref3) {
  var transition = _ref3.transition;
  return transition && 'transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1)';
});
var TitleWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n"])));
var DragLabels = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var DragLabel = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  width: 20px;\n  height: 4px;\n  position: relative;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:first-child {\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n    left: 1px;\n    ", ";\n  }\n\n  &:last-child {\n    border-top-right-radius: 2px;\n    border-bottom-right-radius: 2px;\n    right: 1px;\n    ", ";\n  }\n"])), function (_ref4) {
  var color = _ref4.color;
  return color || 'white';
}, function (_ref5) {
  var deg = _ref5.deg;
  return "transform: rotate(" + deg + "deg)";
}, function (_ref6) {
  var deg = _ref6.deg;
  return "transform: rotate(" + -deg + "deg)";
});
var Title = styled(Text)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  margin: 15px auto;\n  font-family: 'Roboto Condensed', sans-serif;\n  font-weight: bold;\n  font-size: 22px;\n"])));
var MenuItems = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  padding: 16px 6px;\n  height: calc(100% - 150px);\n  ", ";\n  overflow-y: ", ";\n"])), function (_ref7) {
  var isOpen = _ref7.isOpen;
  return isOpen && 'overscroll-behavior: contain';
}, function (_ref8) {
  var fullTop = _ref8.fullTop;
  return fullTop ? 'auto' : 'none';
});
var MenuItemWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: 10px;\n  margin-bottom: 16px;\n"])), function (_ref9) {
  var MenuItemsColor = _ref9.MenuItemsColor;
  return MenuItemsColor || 'rgba(255, 255, 255, 0.12)';
});
var MenuItem = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  padding: 17px 20px;\n  font-family: 'Roboto Condensed', sans-serif;\n  color: white;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  :not(:first-child) {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  p {\n    width: 100%;\n    margin: 0 0 0 20px;\n    font-family: 'Roboto Condensed', sans-serif;\n    font-weight: 100;\n  }\n"])));
var MenuItemIcon = styled(Icon)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 768px) {\n    width: 25px;\n    height: 25px;\n  }\n"])));
var DefaultMenuItems = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  color: white;\n\n  ", " {\n    width: 48%;\n    text-align: center;\n  }\n\n  ", " {\n    padding: 10px;\n    flex-direction: column;\n\n    p {\n      margin: 8px 0 0;\n    }\n  }\n\n  svg {\n    margin-top: 8px;\n  }\n"])), MenuItemWrapper, MenuItem);

var _path;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function Svg25Nyt(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M9 0a9 9 0 109 9 9 9 0 00-9-9zm-.435 11.517v1.181h-4.8v-.984l2.728-2.481a2.088 2.088 0 00.9-1.538 1.141 1.141 0 00-1-1.271 1.084 1.084 0 00-.18-.007c-.755 0-1.206.506-1.206 1.361v.372H3.77v-.374a2.441 2.441 0 114.875-.263v.18a3.055 3.055 0 01-1.286 2.366l-1.61 1.458zm5.684-1.371v.072a2.556 2.556 0 01-2.492 2.617h-.181a2.528 2.528 0 01-2.654-2.217l-.04-.314h1.241l.044.226a1.43 1.43 0 002.822-.309v-.072a1.435 1.435 0 00-2.687-.68l-.1.218-1.077-.341.5-3.994h4.045v1.181h-3.01l-.165 1.341a2.353 2.353 0 011.205-.3 2.48 2.48 0 012.554 2.4c.001.058.001.115-.005.172z",
    fill: "#fff"
  })));
}

var _path$1;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function SvgMessage(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    "data-name": "006-message",
    d: "M12 0A12 12 0 001.591 17.974l-1.546 4.8a.937.937 0 001.18 1.18l4.8-1.546A12 12 0 1012 0zm1.172 12A1.172 1.172 0 1112 10.828 1.172 1.172 0 0113.172 12zm4.687 0a1.172 1.172 0 11-1.172-1.172A1.172 1.172 0 0117.859 12zm-9.375 0a1.172 1.172 0 11-1.172-1.172A1.172 1.172 0 018.484 12zm0 0",
    fill: "#fff"
  })));
}

var ArrowLogo = function ArrowLogo(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || '10',
    height: props.height || '10',
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle_3547",
    "data-name": "Rectangle 3547",
    width: "5.044",
    height: "8",
    fill: "#a9c7e6"
  }))), /*#__PURE__*/React__default.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566",
    transform: "translate(2.198 1)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle_3548",
    "data-name": "Rectangle 3548",
    width: "10",
    height: "10",
    transform: "translate(-2.198 -1)",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553",
    transform: "translate(0.302 0)"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Path_9028",
    "data-name": "Path 9028",
    d: "M4.739,3.261,1.783.306A1.045,1.045,0,0,0,.306,1.783L2.522,4,.306,6.215A1.045,1.045,0,0,0,1.783,7.694L4.739,4.738a1.046,1.046,0,0,0,0-1.477",
    transform: "translate(0 0)",
    fill: props.color || '#fff'
  }))));
};

var height = window.screen.height;
var offsetTop = 40;
var dragLabelDeg = 15;
var moveGap = 70;
var topBound = 20;

var Menu = function Menu(_ref) {
  var configs = _ref.configs,
      background = _ref.background,
      secondaryColor = _ref.secondaryColor,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$initialMenuPosit = _ref.initialMenuPosition,
      initialMenuPosition = _ref$initialMenuPosit === void 0 ? height * 0.3 : _ref$initialMenuPosit,
      zIndexWrapper = _ref.zIndexWrapper,
      MenuItemsColor = _ref.MenuItemsColor;
  var initialHeight = window.innerHeight - initialMenuPosition;

  var _useState = useState(false),
      fullTop = _useState[0],
      setFullTop = _useState[1];

  var _useState2 = useState({
    x: 0,
    y: height
  }),
      controlledPosition = _useState2[0],
      setControlledPosition = _useState2[1];

  var _useState3 = useState(true),
      transition = _useState3[0],
      setTransition = _useState3[1];

  var _useState4 = useState(0),
      labelRotateDeg = _useState4[0],
      setLabelRotateDeg = _useState4[1];

  var _useState5 = useState(false),
      lockScroll = _useState5[0],
      setLockScroll = _useState5[1];

  var _useState6 = useState(initialHeight),
      halfHeight = _useState6[0],
      setHalfHeight = _useState6[1];

  useEffect(function () {
    setHalfHeight(window.innerHeight - initialMenuPosition);
  }, [window.innerHeight]);
  useEffect(function () {
    setHalfHeight(window.innerHeight - initialMenuPosition);
  }, [initialMenuPosition]);
  var menuComponent = document.getElementById('bottom-menu-dropdown');
  var menuRef = ReactDOM.findDOMNode(menuComponent);
  var $body = document.querySelector('body');
  var campaignAction = configs.campaignAction,
      intercomAction = configs.intercomAction,
      menuItems = configs.menuItems;
  useEffect(function () {
    if (isOpen) {
      $body.style.overflow = 'hidden';
    } else {
      $body.style.removeProperty('overflow');
      handleClose();
    }

    setControlledPosition({
      x: 0,
      y: isOpen ? halfHeight : height
    });
  }, [isOpen]);
  useEffect(function () {
    if (menuRef) {
      menuRef.addEventListener('scroll', handleScroll);
      return function () {
        menuRef.removeEventListener('scroll', handleScroll);
      };
    }
  }, [menuRef]);

  var handleScroll = function handleScroll(e) {
    var scrollTop = e.target.scrollTop;

    if (scrollTop === 0) {
      setLockScroll(true);
    }
  };

  var handleClose = function handleClose() {
    setFullTop(false);
    setLabelRotateDeg(0);
    onClose();
  };

  var handleFullSize = function handleFullSize() {
    setFullTop(true);
    setControlledPosition({
      x: 0,
      y: offsetTop
    });
    setLabelRotateDeg(dragLabelDeg);

    if (menuRef) {
      setLockScroll(menuRef.clientHeight >= menuRef.scrollHeight);
    }
  };

  var handleStart = function handleStart() {
    setTransition(false);
  };

  var handleDrag = function handleDrag(e, ui) {
    setControlledPosition({
      x: ui.x,
      y: ui.y
    });
  };

  var handleStop = function handleStop(e, ui) {
    setLockScroll(false);
    setTransition(true);
    var offsetY = halfHeight - ui.y;

    if ((Math.abs(offsetY) < 20 || ui.y - offsetTop < 20 && fullTop) && e.target.closest('.click-handler')) {
      e.target.closest('.click-handler').click();
    } else if (offsetY > moveGap) {
      handleFullSize();
    } else if (offsetY < -moveGap) {
      handleClose();
    } else {
      if (fullTop) {
        handleClose();
      } else {
        setControlledPosition({
          x: 0,
          y: halfHeight
        });
        setLabelRotateDeg(0);
        setFullTop(false);
      }
    }
  };

  return /*#__PURE__*/React__default.createElement(Draggable, {
    handle: ".handle",
    position: controlledPosition,
    bounds: {
      top: topBound,
      left: 0,
      right: 0
    },
    onStart: handleStart,
    onDrag: handleDrag,
    onStop: handleStop
  }, /*#__PURE__*/React__default.createElement(MenuWrapper, {
    background: background,
    transition: transition,
    zIndexWrapper: zIndexWrapper
  }, /*#__PURE__*/React__default.createElement(TitleWrapper, {
    className: "handle"
  }, /*#__PURE__*/React__default.createElement(DragLabels, null, /*#__PURE__*/React__default.createElement(DragLabel, {
    color: secondaryColor,
    deg: labelRotateDeg
  }), /*#__PURE__*/React__default.createElement(DragLabel, {
    color: secondaryColor,
    deg: labelRotateDeg
  })), /*#__PURE__*/React__default.createElement(Title, {
    color: "white",
    align: "center"
  }, "Menu")), /*#__PURE__*/React__default.createElement(MenuItems, {
    id: 'bottom-menu-dropdown',
    fullTop: fullTop,
    isOpen: isOpen,
    className: !fullTop || lockScroll ? 'handle' : ''
  }, /*#__PURE__*/React__default.createElement(DefaultMenuItems, null, /*#__PURE__*/React__default.createElement(MenuItemWrapper, {
    MenuItemsColor: MenuItemsColor
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    className: 'click-handler',
    onClick: function onClick() {
      campaignAction();
      handleClose();
    }
  }, /*#__PURE__*/React__default.createElement(Svg25Nyt, null), /*#__PURE__*/React__default.createElement(Text, {
    align: 'center'
  }, "25 nyt"))), /*#__PURE__*/React__default.createElement(MenuItemWrapper, {
    MenuItemsColor: MenuItemsColor
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    className: 'click-handler',
    onClick: function onClick() {
      intercomAction();
      handleClose();
    }
  }, /*#__PURE__*/React__default.createElement(SvgMessage, null), /*#__PURE__*/React__default.createElement(Text, {
    align: 'center'
  }, "Kundeservice")))), menuItems.map(function (items, index) {
    return /*#__PURE__*/React__default.createElement(MenuItemWrapper, {
      key: "dropdown-menu-" + index,
      MenuItemsColor: MenuItemsColor
    }, items.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(MenuItem, {
        key: "menu-item-" + index,
        className: 'click-handler',
        onClick: function onClick() {
          item.action();
          handleClose();
        }
      }, /*#__PURE__*/React__default.createElement(MenuItemIcon, {
        src: item.logo,
        color: 'white',
        width: '20px',
        height: '20px'
      }), /*#__PURE__*/React__default.createElement(Text, null, item.title), /*#__PURE__*/React__default.createElement(ArrowLogo, {
        width: 12,
        height: 12,
        color: secondaryColor || 'white'
      }));
    }));
  }))));
};

Menu.propTypes = {
  configs: PropTypes.shape({
    campaignAction: PropTypes.func.isRequired,
    intercomAction: PropTypes.func.isRequired,
    zIndexWrapper: PropTypes.number,
    MenuItemsColor: PropTypes.string,
    menuItems: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      logo: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired
    }))).isRequired
  }).isRequired,
  background: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired
};

var _path$2, _g, _g2, _g3;

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function SvgMore(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    viewBox: "0 0 18 18"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    "data-name": "Rectangle 3307",
    fill: "none",
    d: "M0 0h18v18H0z"
  })), _g || (_g = /*#__PURE__*/createElement("g", {
    "data-name": "Rectangle 3562",
    transform: "translate(0 6.5)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/createElement("rect", {
    width: 5,
    height: 5,
    rx: 2.5,
    stroke: "none"
  }), /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/createElement("g", {
    "data-name": "Rectangle 3563",
    transform: "translate(6.5 6.5)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/createElement("rect", {
    width: 5,
    height: 5,
    rx: 2.5,
    stroke: "none"
  }), /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/createElement("g", {
    "data-name": "Rectangle 3564",
    transform: "translate(13 6.5)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/createElement("rect", {
    width: 5,
    height: 5,
    rx: 2.5,
    stroke: "none"
  }), /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 2,
    fill: "none"
  }))));
}

var _path$3, _g$1, _g2$1, _g3$1;

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    "data-name": "Rectangle 3307",
    fill: "none",
    d: "M0 0h18v18H0z"
  })), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    "data-name": "Rectangle 3562",
    transform: "rotate(45 -.053 5.25)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/createElement("rect", {
    width: 18,
    height: 3,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 2,
    rx: 1,
    fill: "none"
  }))), _g2$1 || (_g2$1 = /*#__PURE__*/createElement("g", {
    "data-name": "Rectangle 3563",
    transform: "translate(7.5 7.5)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/createElement("rect", {
    width: 3,
    height: 3,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "none"
  }))), _g3$1 || (_g3$1 = /*#__PURE__*/createElement("g", {
    "data-name": "Rectangle 3564",
    transform: "rotate(-45 18.053 5.25)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/createElement("rect", {
    width: 18,
    height: 3,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 2,
    rx: 1,
    fill: "none"
  }))));
}

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11, _templateObject12, _templateObject13;
var hide = keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  100% {\n    bottom: 0;\n  }\n"])));
var Wrapper = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  z-index: ", ";\n  position: fixed;\n  overflow: scroll;\n  overflow-x: hidden;\n  ", "\n  height: ", ";\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, ", ");\n  ", ";\n"])), function (_ref) {
  var zIndexWrapper = _ref.zIndexWrapper;
  return zIndexWrapper || 111;
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return !isOpen && css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n      animation: ", " 0s ease-in 300ms forwards;\n    "])), hide);
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? '100%' : '60px';
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? '0.5' : '0';
}, function (_ref5) {
  var isOpen = _ref5.isOpen;
  return css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n      transition: background 300ms cubic-bezier(0.4, 0, 0.2, 1),\n        transform 300ms cubic-bezier(0.4, 0, 0.2, 1),\n        position 300ms cubic-bezier(0.4, 0, 0.2, 1)\n          ", ";\n    "])), !isOpen && ", height 0ms ease 300ms");
});
var MenuWrapper$1 = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: ", ";\n  display: block;\n  box-sizing: border-box;\n  overflow: hidden;\n  width: 100%;\n  box-shadow: 0 0 10px #0e449a33;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);\n"])), function (_ref6) {
  var zIndexWrapper = _ref6.zIndexWrapper;
  return zIndexWrapper + 2 || 113;
});
var Container = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  background: ", ";\n  display: flex;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  overflow: hidden;\n  padding: 0 7px;\n  height: 60px;\n  justify-content: space-between;\n  box-sizing: border-box;\n  align-items: center;\n  @media (min-width: 768px) {\n    padding: 0 60px;\n  }\n"])), function (_ref7) {
  var background = _ref7.background;
  return background || '#fff';
});
var MenuItem$1 = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  font-size: 12px;\n  border: none;\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  padding: 6px 0;\n  margin-top: 2px;\n  box-sizing: border-box;\n\n  width: 60px;\n  height: 50px;\n\n  ", ";\n\n  ", ";\n"])), function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && css(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n      ", ", ", ", ", " {\n        opacity: 0.5;\n      }\n    "])), NavIcon, StyledText, Badge);
}, function (_ref9) {
  var active = _ref9.active;
  return active && css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n      //background: rgba(255, 255, 255, 0.1);\n      border-radius: 5px;\n\n      &:before {\n        content: '';\n        display: block;\n        position: absolute;\n        top: -6px;\n        left: 0;\n        width: 100%;\n        height: 4px;\n        background: #ffd804;\n        border-radius: 4px;\n      }\n    "])));
});
var iconStyles = css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n  width: 18px;\n  height: 18px;\n  margin-bottom: 5px;\n  @media (min-width: 768px) {\n    width: 25px;\n    height: 25px;\n  }\n"])));
var NavIcon = styled(Icon)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), iconStyles);
var StyledText = styled(Text)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  font-size: 10px;\n  margin: 0;\n  line-height: 1.3;\n  text-align: center;\n  font-weight: normal;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: auto;\n  text-decoration: none;\n  font-family: 'Roboto Condensed', sans-serif;\n  @media (min-width: 768px) {\n    font-size: 12px;\n  }\n"])));
var Badge = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto Condensed', sans-serif;\n  font-size: 10px;\n  color: ", ";\n  border-radius: 100%;\n  width: 13px;\n  height: 13px;\n  position: absolute;\n  top: 0;\n  left: 35px;\n  background: white;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n"])), function (_ref10) {
  var color = _ref10.color;
  return color;
});

var BottomMenu = function BottomMenu(_ref11) {
  var config = _ref11.config;

  var _useState = useState(false),
      menuState = _useState[0],
      setMenuState = _useState[1];

  var _useState2 = useState(false),
      moreActive = _useState2[0],
      setMoreActive = _useState2[1];

  var backgroundColor = config.backgroundColor,
      secondaryColor = config.secondaryColor,
      initialMenuPosition = config.initialMenuPosition,
      menuItems = config.menuItems,
      dropDownMenuItems = config.dropDownMenuItems,
      zIndexWrapper = config.zIndexWrapper,
      MenuItemsColor = config.MenuItemsColor;
  useEffect(function () {
    setMoreActive(dropDownMenuItems.uniqItemsActive && !menuItems.some(function (item) {
      return !!item.active;
    }));
  }, [window.location.href, config]);

  var openMenu = function openMenu() {
    setMenuState(!menuState);
  };

  return /*#__PURE__*/React__default.createElement(Wrapper, {
    isOpen: menuState,
    zIndexWrapper: zIndexWrapper,
    onClick: function onClick(e) {
      if (menuState && e.target === e.currentTarget) {
        setMenuState(false);
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuWrapper$1, {
    zIndexWrapper: zIndexWrapper
  }, config ? /*#__PURE__*/React__default.createElement(Container, {
    background: backgroundColor
  }, menuItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(MenuItem$1, {
      key: "bottom-menu-" + index,
      active: !menuState && item.active,
      disabled: item.disabled,
      onClick: function onClick() {
        if (!item.disabled) {
          item.action();
          setMenuState(false);
        }
      }
    }, /*#__PURE__*/React__default.createElement(NavIcon, {
      src: item.icon,
      color: 'white'
    }), /*#__PURE__*/React__default.createElement(StyledText, {
      color: secondaryColor || 'white',
      "short": true,
      align: 'center'
    }, item.title), !!item.badge && /*#__PURE__*/React__default.createElement(Badge, {
      color: backgroundColor
    }, item.badge));
  }), /*#__PURE__*/React__default.createElement(MenuItem$1, {
    onClick: openMenu,
    active: menuState || moreActive
  }, menuState ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SvgClose, {
    style: {
      verticalAlign: 'middle',
      marginBottom: '5px',
      width: 18,
      height: 18
    }
  }), /*#__PURE__*/React__default.createElement(StyledText, {
    color: secondaryColor || 'white',
    "short": true,
    align: 'center'
  }, "Luk")) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SvgMore, {
    style: {
      verticalAlign: 'middle',
      marginBottom: '5px',
      width: 18,
      height: 18
    }
  }), /*#__PURE__*/React__default.createElement(StyledText, {
    color: secondaryColor || 'white',
    "short": true,
    align: 'center'
  }, "Mere")))) : null), /*#__PURE__*/React__default.createElement(Menu, {
    isOpen: menuState,
    configs: dropDownMenuItems,
    background: backgroundColor,
    secondaryColor: secondaryColor,
    initialMenuPosition: initialMenuPosition,
    zIndexWrapper: zIndexWrapper,
    onClose: function onClose() {
      setMenuState(false);
    },
    MenuItemsColor: MenuItemsColor
  }));
};

BottomMenu.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    initialMenuPosition: PropTypes.number,
    zIndexWrapper: PropTypes.number,
    MenuItemsColor: PropTypes.string,
    menuItems: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      icon: PropTypes.string,
      action: PropTypes.func,
      active: PropTypes.bool,
      disabled: PropTypes.bool,
      badge: PropTypes.number
    })),
    dropDownMenuItems: PropTypes.object
  })
};

export { BottomMenu };
//# sourceMappingURL=index.modern.js.map
